module.exports = __webpack_public_path__ + "static/media/paper.b6d88e61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/paper.svg
// module id = 1194
// module chunks = 68